import React from 'react';
import Button from '../../../../../../components/Button';
import FixedBottomNavBar from '../../../../../../components/FixedBottomNavBar';
import './HomeSubSaveNavbar.scss';

const HomeSubSaveNavbar = (props) => {
  const { onSubmit } = props;

  return (
    <FixedBottomNavBar className="home-sub-save-navbar">
      <div className="button-group">
        <Button color="primary" text="등록하기" onClick={onSubmit} />
      </div>
    </FixedBottomNavBar>
  );
};

export default HomeSubSaveNavbar;
